import React from 'react';

const JS_Debugging = () => {
  return (
    <div >
      <h1>JS_Debugging</h1>
      <p>Placeholder component for: "JS Debugging"</p>
    </div>
  );
};

export default JS_Debugging;
